import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import s from './RadioButton.module.scss';

const RadioButton = ({
    name,
    value,
    label,
    id,
    checked,
    register,
    errors,
    error,
    fullWidth,
}) => {
    const fieldId = _.isEmpty(id) ? name : id;

    const classes = classNames(
        s['RadioButton'],
        {[s['RadioButton--Error']]: errors[name] || error},
    );

    return (
        <div className={classes}>
            <input
                className={s['RadioButton__Input']}
                id={fieldId}
                type="radio"
                name={name}
                value={value}
                defaultChecked={checked}
                {...register}
            />
            <label className={classNames(s['RadioButton__Label'], {
                [s['RadioButton__Label--FullWidth']]: fullWidth
            })} htmlFor={fieldId}>
                {label}
            </label>
        </div>
    );
};

RadioButton.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.any,
    id: PropTypes.string,
    checked: PropTypes.bool,
    errors: PropTypes.object,
    error: PropTypes.bool,
    register: PropTypes.object,
    fullWidth: PropTypes.bool,
};

RadioButton.defaultProps = {
    name: '',
    label: '',
    value: '',
    id: '',
    checked: false,
    errors: {},
    error: false,
    register: null,
    onChange: null,
    fullWidth: false,
};

export default RadioButton;
